<script>
export default {
  name: 'CompareOddsIcon',
};
</script>

<template>
  <svg
    width="22px"
    height="22px"
    viewBox="0 0 22 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch -->
    <title>icon/compare odds</title>
    <desc>Created with Sketch.</desc>
    <defs />
    <g id="Symbols" 
       stroke="none" 
       stroke-width="1" 
       fill="none" 
       fill-rule="evenodd">
      <g id="icon/compare-odds" fill="#7C8482">
        <path
          id="Fill-1"
          d="M19.4999,5.6745 L9.1209,3.0375 C8.4749,2.8735 7.8189,3.2635 7.6549,3.9095 L5.0179,14.2885 C4.8539,14.9345 5.2439,15.5905 5.8899,15.7545 L16.2689,18.3915 C16.9149,18.5555 17.5709,18.1655 17.7339,17.5195 L20.3719,7.1405 C20.5359,6.4945 20.1459,5.8385 19.4999,5.6745 M4.0479,14.0425 L6.0199,6.2815 L2.0279,6.8785 C1.3689,6.9765 0.9149,7.5905 1.0139,8.2485 L2.5549,18.5665 C2.6529,19.2245 3.2669,19.6785 3.9259,19.5805 L12.0879,18.3615 L5.6429,16.7235 C4.4639,16.4235 3.7499,15.2205 4.0479,14.0425"
        />
      </g>
    </g>
  </svg>
</template>
